import StyleConfig from './StyleConfig'
import AppConfig from './AppConfig'
import Translations from './Translations'
import Routes from './Routes'
import Category from './Category'

export default {
  StyleConfig,
  AppConfig,
  Translations,
  Routes,
  Category,
}
